import { useTheme } from "@emotion/react";
import { LoadingButton } from "@mui/lab";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useMediaQuery,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../../context/AuthContext";
import { currencyFormat } from "../../../../components/NewDetail/calculations/utils";

const AddSalesTicketItemDialog = ({ open, onClose, onAdd }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { authToken, ezorder } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [consumables, setConsumables] = useState([]);

  const handleClose = () => {
    onClose();
  };

  const getConsumables = async () => {
    try {
      setLoading(true);
      const response = await ezorder.get(`/consumables`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status == 200 || response.status === 201) {
        // navigate to order details page
        //orderDispatch({ type: "SET ORDER STATE", payload: initialOrder });
        setConsumables(response.data.consumables);
      }
    } catch (error) {
      console.log(error);
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        console.log("error", error.response.data.error);
      } else {
        // Something went really bad
        console.log(error);
        console.log("error", error);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getConsumables();
  }, []);

  return (
    <Dialog
      fullScreen={isSmallScreen}
      maxWidth="md"
      fullWidth={true}
      open={open}
      onClose={() => {
        if (!loading) handleClose();
      }}
    >
      <DialogTitle>Add Sales Ticket Item</DialogTitle>
      <DialogContent>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell align="left">ID</TableCell>
                <TableCell align="left">Description</TableCell>
                <TableCell align="left">UOM</TableCell>
                <TableCell align="left">Retail price</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {consumables.map((consumable, index) => {
                return (
                  <TableRow
                    key={consumable.id}
                    onClick={() => {
                      onAdd(consumable);
                    }}
                    sx={{
                      cursor: "pointer",
                      "&:hover": {
                        background: "#eeeeee",
                      },
                    }}
                  >
                    <TableCell align="left">{consumable.id}</TableCell>
                    <TableCell align="left">{consumable.description}</TableCell>
                    <TableCell align="left">{consumable.uom}</TableCell>
                    <TableCell align="left">
                      {currencyFormat(consumable.retailPrice ?? 0)}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          loading={loading}
          onClick={() => {
            if (!loading) handleClose();
          }}
        >
          Cancel
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default AddSalesTicketItemDialog;
